import { createGamificationQueries } from '@astra/core/queries';
import { fetchWithAuth } from '../../lib/apiClient';
import { supabase } from '../../lib/supabaseClient';

export const { useUserStreaks, useTodaySummary } = createGamificationQueries({ fetchWithAuth, supabase });
